import { ChangeDetectionStrategy, Component, inject, input } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { HolesLegendPanelComponent } from '../../shared/holes-legend-panel/holes-legend-panel.component';
import { BlastHolesStateService } from '../../blast-holes-state.service';
import { HOLES_VIEW_LABEL_KEYS, HolesView } from '../../blast-holes.types';

/**
 * Temporary body for views that are not implemented yet.
 * Renders the legend cell (when the view has one) and the panel cell with the
 * loaded hole count, so the shell can be tested end to end before each view lands.
 */
@Component({
  selector:        'app-holes-view-placeholder',
  standalone:      true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports:         [TranslateModule, HolesLegendPanelComponent],
  templateUrl:     './holes-view-placeholder.component.html',
  styleUrls:       ['./holes-view-placeholder.component.scss'],
})
export class HolesViewPlaceholderComponent {
  readonly view      = input.required<HolesView>();
  readonly hasLegend = input<boolean>(true);

  protected readonly state = inject(BlastHolesStateService);
  protected readonly labelKeys = HOLES_VIEW_LABEL_KEYS;
}
